module.exports = __webpack_public_path__ + "media/message.49e2173e.mp3";